import '@mantine/core/styles.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { createFirebaseAuthSource } from './auth/firebaseAuthSource';
import { adminConfig } from './config/env';

const demo = import.meta.env.DEV && adminConfig.useFirebaseEmulators && new URLSearchParams(location.search).get('demo') === '1';
if (!demo && adminConfig.sentryDsn !== null) {
  void import('./monitoring/sentry').then(({ initSentry }) => initSentry());
}

const container = document.getElementById('root');
if (container === null) {
  throw new Error('No se encontró el contenedor #root');
}

if (demo) {
  void import('./demo/DemoApp').then(({ renderDemo }) => renderDemo(container));
} else {
createRoot(container).render(
  <StrictMode>
    <App
      authSource={createFirebaseAuthSource()}
    />
  </StrictMode>,
);
}
